import { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router";
import { TaskData } from "../../modules/network";
import useCompleteTask from "../../modules/tasks/hooks/use-complete-task";
import { getMapRoute } from "../../routes/routes";
import NextButton from "../next-button";
import BackLink from "./back";
import TaskXXX from "./tasks/placeholder";
import Task101 from "./tasks/task-101";
import Task102 from "./tasks/task-102";
import Task103 from "./tasks/task-103";
import Task104 from "./tasks/task-104";
import Task105 from "./tasks/task-105";
import Task106 from "./tasks/task-106";
import Task201 from "./tasks/task-201";
import Task202 from "./tasks/task-202";
import Task203 from "./tasks/task-203";
import Task204 from "./tasks/task-204";
import Task205 from "./tasks/task-205";
import Task206 from "./tasks/task-206";
import Task301 from "./tasks/task-301";
import Task302 from "./tasks/task-302";
import Task303 from "./tasks/task-303";
import Task304 from "./tasks/task-304";
import Task305 from "./tasks/task-305";
import Task306 from "./tasks/task-306";
import Task401 from "./tasks/task-401";
import Task402 from "./tasks/task-402";
import Task403 from "./tasks/task-403";
import Task404 from "./tasks/task-404";
import Task405 from "./tasks/task-405";
import Task406 from "./tasks/task-406";

type Props = {
    task: TaskData
}

const Task: React.FC<Props> = ({ task }) => {
    const completeTask = useCompleteTask();
    const [showCompleteButtomn, setShowCompleteButton] = useState(false);
    const history = useHistory();

    const onClickComplete = useCallback(() => {
        completeTask(task.id);
        history.push(getMapRoute())
    }, [completeTask, task, history]);

    const onTaskComplete = useCallback(() => {
        setShowCompleteButton(true);
    }, [setShowCompleteButton]);

    const pathName = useMemo(() => {
        switch (true) {
            case ['t-101', 't-102', 't-103', 't-104', 't-105', 't-106'].includes(task.id):
                return 'Czytanie wzmacnia zdrowie';
            case ['t-201', 't-202', 't-203', 't-204', 't-205', 't-206'].includes(task.id):
                return 'Czytanie wzmacnia relacje';
            case ['t-301', 't-302', 't-303', 't-304', 't-305', 't-306'].includes(task.id):
                return 'Czytanie wzmacnia wiedzę';
            case ['t-401', 't-402', 't-403', 't-404', 't-405', 't-406'].includes(task.id):
                return 'Czytanie wzmacnia wyobraźnię';
        }

        return '';
    }, [task]);

    const Task = useMemo(() => {

        switch (task.id) {
            case 't-101':
                return <Task101 onComplete={onTaskComplete} />

            case 't-102':
                return <Task102 onComplete={onTaskComplete} />

            case 't-103':
                return <Task103 onComplete={onTaskComplete} />

            case 't-104':
                return <Task104 onComplete={onTaskComplete} />

            case 't-105':
                return <Task105 onComplete={onTaskComplete} />

            case 't-106':
                return <Task106 onComplete={onTaskComplete} />

            case 't-201':
                return <Task201 onComplete={onTaskComplete} />

            case 't-202':
                return <Task202 onComplete={onTaskComplete} />

            case 't-203':
                return <Task203 onComplete={onTaskComplete} />

            case 't-204':
                return <Task204 onComplete={onTaskComplete} />

            case 't-205':
                return <Task205 onComplete={onTaskComplete} />

            case 't-206':
                return <Task206 onComplete={onTaskComplete} />

            case 't-401':
                return <Task401 onComplete={onTaskComplete} />

            case 't-402':
                return <Task402 onComplete={onTaskComplete} />

            case 't-403':
                return <Task403 onComplete={onTaskComplete} />

            case 't-404':
                return <Task404 onComplete={onTaskComplete} />

            case 't-405':
                return <Task405 onComplete={onTaskComplete} />

            case 't-406':
                return <Task406 onComplete={onTaskComplete} />

            case 't-301':
                return <Task301 onComplete={onTaskComplete} />

            case 't-302':
                return <Task302 onComplete={onTaskComplete} />

            case 't-303':
                return <Task303 onComplete={onTaskComplete} />

            case 't-304':
                return <Task304 onComplete={onTaskComplete} />

            case 't-305':
                return <Task305 onComplete={onTaskComplete} />

            case 't-306':
                return <Task306 onComplete={onTaskComplete} />
        }

        return <TaskXXX onComplete={onTaskComplete} />
    }, [onTaskComplete, task]);


    return <>
        <div className="task-header">
            <BackLink />
            <h1>{pathName}</h1>
        </div>
        <div className="task-box">
            {Task}
        </div>
        <div className="task-footer">
            {showCompleteButtomn && <NextButton onClick={onClickComplete}>Zakończ<br />zadanie</NextButton>}
        </div>
    </>
}

export default Task;
